export type Season = { id: string; name: string; startsOn: string; endsOn: string; isActive: boolean };

export const seasonOfDate = <T extends Pick<Season, "startsOn" | "endsOn">>(seasons: T[], date: string) =>
  seasons.find((season) => season.startsOn <= date && date <= season.endsOn);

export const activeSeasonOf = <T extends Pick<Season, "isActive" | "startsOn">>(seasons: T[]) =>
  seasons.find((season) => season.isActive) ?? [...seasons].sort((a, b) => b.startsOn.localeCompare(a.startsOn))[0];

export const clampDate = (date: string, season: Pick<Season, "startsOn" | "endsOn">) =>
  date < season.startsOn ? season.startsOn : date > season.endsOn ? season.endsOn : date;

export const seasonsOverlap = (a: Pick<Season, "startsOn" | "endsOn">, b: Pick<Season, "startsOn" | "endsOn">) =>
  a.startsOn <= b.endsOn && b.startsOn <= a.endsOn;
